export default {
	create (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff/create', params)
	},
	update (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff/update', params)
	},
	delete (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff/delete', params)
	},
	can_delete (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff/can_delete', params)
	},
	all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff/all', params)
	},
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff/one', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/Staff.js